export default __webpack_public_path__ + "static/media/602.de7df802.png";